var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormReport } from './components/Form';
import NotFinish from './components/NotFinish';
import ReportHeader from './components/ReportHeader/ReportHeader';
import VideoQuestion from './components/VideoQuestion';
import { INTERVIEW_STATUS } from "../../enum/ai-report";
import { PostAiInterviewResult } from "../../services/ai-report";
import { useAiReportStore } from "../../store/ai-report/global-store";
import { useRequest } from 'ahooks';
import { Box, Button, Paper, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
var NO_ANSWER = INTERVIEW_STATUS.NO_ANSWER;
var AiReportRoot = forwardRef(function (props, ref) {
    var token = props.token, customScore = props.customScore, reminderSent = props.reminderSent, operableButtons = props.operableButtons, onLoad = props.onLoad, onSendReminderClick = props.onSendReminderClick, fetchFormResult = props.fetchFormResult, fetchCandidateInfo = props.fetchCandidateInfo, fetchReportUrl = props.fetchReportUrl, isExportPdf = props.isExportPdf;
    var firstLoad = useRef(true);
    var _a = useAiReportStore(), updateState = _a.updateState, updateReportResult = _a.updateReportResult, reportResult = _a.reportResult;
    var _b = (reportResult || {}).collection, collection = _b === void 0 ? [] : _b;
    var _c = useRequest(function () { return PostAiInterviewResult([token]); }, {
        manual: true,
        onSuccess: function (_a) {
            var list = _a.data.list;
            var result = list[0];
            updateReportResult(result);
            if (firstLoad.current) {
                var pageStepIndexes_1 = [];
                result.steps.forEach(function (_a, index) {
                    var videoUrl = _a.answer.videoUrl;
                    if (videoUrl) {
                        pageStepIndexes_1.push(index);
                    }
                });
                firstLoad.current = false;
                onLoad === null || onLoad === void 0 ? void 0 : onLoad(__assign({ pageStepIndexes: pageStepIndexes_1 }, result));
            }
        },
    }), data = _c.data, loading = _c.loading, postAiInterviewResult = _c.run;
    var status = (data === null || data === void 0 ? void 0 : data.data.list[0].status) || NO_ANSWER;
    var handleRefreshSuccess = useCallback(function () {
        postAiInterviewResult();
    }, [postAiInterviewResult]);
    useImperativeHandle(ref, function () { return ({
        handleRefresh: function () { return postAiInterviewResult(); },
    }); });
    useEffect(function () {
        firstLoad.current = true;
        postAiInterviewResult();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    useEffect(function () {
        updateState(props);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(props)]);
    var aiReportResult = useMemo(function () {
        if (status === NO_ANSWER) {
            return (_jsxs(Box, __assign({ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", style: { marginTop: '149px' } }, { children: [_jsx(Box, { children: _jsx("img", { src: "//webcdn.fbmms.cn/web/saas/asset/image/CandidateInfoEmpty.png", alt: "", style: { width: '140px', height: '140px' } }) }), _jsx(Box, __assign({ mt: 2 }, { children: _jsx(Typography, __assign({ variant: "body1", color: "textPrimary", style: { fontWeight: '500' } }, { children: "\u8BE5\u5019\u9009\u4EBA\u5C1A\u672A\u5F00\u59CB\u9762\u8BD5" })) })), (operableButtons === null || operableButtons === void 0 ? void 0 : operableButtons.includes('sendReminder')) && (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ style: { marginTop: '2px' } }, { children: _jsx(Typography, __assign({ variant: "body2", color: "textSecondary" }, { children: "\u82E5\u957F\u65F6\u95F4\u672A\u5F00\u59CB\uFF0C\u5EFA\u8BAE\u4F60\u7ED9\u5019\u9009\u4EBA\u53D1\u9001\u77ED\u4FE1\u63D0\u9192" })) })), _jsx(Box, __assign({ mt: 2 }, { children: _jsx(Button, __assign({ size: "large", variant: "outlined", color: "primary", disabled: reminderSent, onClick: onSendReminderClick }, { children: reminderSent ? '已提醒' : '发送提醒' })) }))] }))] })));
        }
        else {
            return (_jsxs(Stack, { children: [_jsx(NotFinish, {}), _jsxs(Box, __assign({ pb: 3, sx: {
                            background: '#F0F9FF',
                            backgroundImage: "url('//webcdn.fbmms.cn/assets/9kTa/pmsfSOeFx_7jhhsV9f_ta')",
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center top',
                            paddingTop: (collection === null || collection === void 0 ? void 0 : collection.length) > 0 ? 0 : 3,
                        } }, { children: [(collection === null || collection === void 0 ? void 0 : collection.length) > 0 && (_jsx(ReportHeader, { customScore: customScore, onRefreshSuccess: handleRefreshSuccess, fetchCandidateInfo: fetchCandidateInfo, status: status, fetchReportUrl: fetchReportUrl })), _jsx(FormReport, { fetchFormResult: fetchFormResult }), _jsx(Paper, __assign({ variant: "outlined", sx: { zIndex: 1, position: 'relative', mx: 2, borderRadius: 4 } }, { children: _jsx(VideoQuestion, { isExportPdf: isExportPdf }) }))] }))] }));
        }
    }, [
        status,
        operableButtons,
        reminderSent,
        onSendReminderClick,
        collection === null || collection === void 0 ? void 0 : collection.length,
        customScore,
        handleRefreshSuccess,
        fetchCandidateInfo,
        fetchReportUrl,
        fetchFormResult,
        isExportPdf,
    ]);
    return (_jsx(Box, __assign({ loading: firstLoad.current && loading, sx: { width: '100%', minHeight: '618px', height: '100%', margin: '0 auto', overflow: 'auto' } }, { children: aiReportResult })));
});
AiReportRoot.displayName = 'AiReportRoot';
export default memo(AiReportRoot);
